import { cn } from '@ggs/utils'
import MUIDataTable from 'mui-datatables'
import './DataTable.scss'

/**
 * @typedef {import('mui-datatables').MUIDataTableProps} MUIDataTableProps
 */

/**
 * @typedef {Object} DataTableProps
 * @property {string} title
 * @property {string} className
 */

/**
 * @typedef {DataTableProps & MUIDataTableProps} ComponentProps
 */

/**
 * @param {ComponentProps} props
 * @return {JSX.Element}
 */
const DataTable = (props) => {

  const { className, title, columns, data, options, ...extraProps } = props

  return (
    <MUIDataTable
      // @ts-ignore
      className={cn('r-data-table', className)}
      title={title}
      columns={columns}
      data={data}
      options={{
        download: false,
        filter: false,
        jumpToPage: true,
        print: false,
        responsive: 'simple',
        rowHover: false,
        rowsPerPage: 20,
        rowsPerPageOptions: [],
        search: false,
        selectableRows: 'none',
        sort: true,
        viewColumns: false,
        ...options
      }}
      {...extraProps}
    />
  )
}

export default DataTable

